import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  BudgetedHoursCalculationMode,
  BudgetedHoursConfig,
  updateProjectTemplate,
  useActiveProjectTemplate,
} from 'data/templates/projects';
import { getBudgetedHoursConfigFromTemplate } from './utils';

export const useBudgetHourFieldsForActiveTemplate = (): {
  budgetedHoursConfig?: BudgetedHoursConfig;
  updateBugdetHoursConfig: (budgetHours?: BudgetedHoursConfig) => void;
} => {
  const template = useActiveProjectTemplate();
  const { templateContent } = template;
  const dispatch = useDispatch();
  const bugdetedHoursConfig = getBudgetedHoursConfigFromTemplate(template);

  const updateBugdetHoursConfig = useCallback(
    (_budgetHours?: BudgetedHoursConfig) => {
      const budgetedHoursValues =
        _budgetHours == null
          ? {
              budgetedHours: undefined,
              autoBudgetedHours: false,
            }
          : _budgetHours.mode === BudgetedHoursCalculationMode.Auto
          ? {
              budgetedHours: undefined,
              autoBudgetedHours: true,
            }
          : {
              budgetedHours: _budgetHours.value,
              autoBudgetedHours: false,
            };

      dispatch(
        updateProjectTemplate({
          ...template,
          autoBudgetedHours: budgetedHoursValues.autoBudgetedHours,
          templateContent: {
            ...templateContent,
            budgetedHours: budgetedHoursValues.budgetedHours,
          },
        }),
      );
    },
    [dispatch, template, templateContent],
  );

  return {
    budgetedHoursConfig: bugdetedHoursConfig,
    updateBugdetHoursConfig,
  };
};
